const manAdd = {
    path: 'man-add',
    component: resolve => require(['@/pages/admin/message/man-add.vue'], resolve)
}

export default manAdd